<!--Navbar-->
<div class="navbar p-0">
  <div class="container-fluid w-1400">
    <div class="row w-100">
      <div class="col-8 p-0 col-sm-6">
          <img class="img-fluid" width="300px" src="assets/images/claro-certicamara-logos.png" alt="Claro logo">
      </div>

      <div class="col-auto col-md-6 text-muted p-0 justify-content-end">
        <div class="row align-items-center">
          <div class="col-auto p-0 d-none d-md-block">
            <div class="small">Bienvenido,</div>
            <div class="fw-bold" *ngIf="name && lastName">{{ name }} {{ lastName }}</div>
          </div>
          <div class="col-auto matAccountmenu offset-2 offset-md-0">
            <button class="p-0" [matMenuTriggerFor]="accountMenu"><mat-icon>
              account_circle
            </mat-icon></button>
            <mat-menu #accountMenu="matMenu" xPosition="before">
              <a routerLink="/pv/profile"><button mat-menu-item>Perfil</button></a>
              <button mat-menu-item (click)="logOut()">Cerrar sesión</button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
